import React, {useMemo, memo} from 'react';
import clsx from 'clsx';

// Imports => Utilities
import {AcIsSet, AcIsEmptyString, AcGenerateThemeClassNames} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-loader-inline',
  LOADING: 'ac-loader-inline--loading',
  COVER: 'ac-loader-inline--cover',
  DENSE: 'ac-loader-inline--dense',
  THEME: AcGenerateThemeClassNames('ac-loader-inline'),
  VISUAL: 'ac-loader-inline__visual',
  LABEL: 'ac-loader-inline__label',
};

const AcLoaderInline: React.FC<{label?: string, theme?: string, loading?: boolean, dense?: boolean, cover?: boolean} & React.HTMLAttributes<HTMLDivElement>> = memo(
  ({
    label = null,
    theme = 'default',
    loading = false,
    dense = false,
    cover = false,
    className,
    ...rest
  }) => {
    const getLabelClassNames = useMemo(() => {
      return clsx(_CLASSES.LABEL);
    }, []);

    const getVisualClassNames = useMemo(() => {
      return clsx(_CLASSES.VISUAL);
    }, []);

    const getMainClassNames = useMemo(() => {
      return clsx(
        _CLASSES.MAIN,
        dense && _CLASSES.DENSE,
        cover && _CLASSES.COVER,
        theme && _CLASSES.THEME[theme.toUpperCase()],
        loading && _CLASSES.LOADING,
        className
      );
    }, [theme, dense, cover, loading, className]);

    const renderLabel = useMemo(() => {
      if (!AcIsSet(label)) return null;
      if (AcIsEmptyString(label)) return null;

      return (
        <div
          className={getLabelClassNames}
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />
      );
    }, [label]);

    return (
      <div className={getMainClassNames} {...rest}>
        <div className={getVisualClassNames} />
        {renderLabel}
      </div>
    );
  }
);

AcLoaderInline.displayName = 'AcLoaderInline';

export {AcLoaderInline};
export default AcLoaderInline;
